import doc              from '@widesk-core/decorators/doc';
import model            from '@widesk-core/decorators/model';
import ShopServiceModel from '@/models/ShopServiceModel';

@model.cacheDuration()
@model.urnResource('product_variant_status')
@doc.path('/product_variant_statuses/{?id}')
export default class ProductVariantStatusModel extends ShopServiceModel {
	private declare _tsFilters: {
		'reference': Shop_ProductVariantStatusReference;
	};

	private declare _tsSorts: {
		'id': string;
		'label': string;
	};

	@doc.string declare label: string;
	@doc.string declare reference: Shop_ProductVariantStatusReference;

	public get color() {
		switch (this.reference) {
			case 'archived':
				return 'purple';
			case 'disabled':
				return 'red';
			case 'enabled':
				return 'green';
			case 'in_creation':
				return 'blue';
			case 'paused':
				return 'black';
		}
	}
}